namespace GeniuzPOS.Lookups {
    export interface VwApprovalGroupRow {
        Id?: number;
        ApprGroupCode?: string;
        ApprGroupName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace VwApprovalGroupRow {
        export const idProperty = 'ApprGroupCode';
        export const nameProperty = 'ApprGroupCode';
        export const localTextPrefix = 'Lookups.VwApprovalGroup';
        export const lookupKey = 'VwApprovalGroupRow';

        export function getLookup(): Q.Lookup<VwApprovalGroupRow> {
            return Q.getLookup<VwApprovalGroupRow>('VwApprovalGroupRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ApprGroupCode = "ApprGroupCode",
            ApprGroupName = "ApprGroupName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
